<nz-form-item class="pf-form-item">
    @if (!!label) {
        <nz-form-label
            class="pf-form-label"
            [nzRequired]="pfRequired"
            [title]="label"
            [nzNoColon]="true"
            [nzTooltipTitle]="tooltip"
            >{{ label }}
        </nz-form-label>
    }
    <nz-form-control
        class="pf-form-control"
        [nzAutoTips]="autoTips"
        nzHasFeedback>
        <div class="input-container">
            <ng-template #tagPlaceHolder let-selectedList
                >+ {{ selectedList.length }}
            </ng-template>
            @if (!tree) {
                <nz-select
                    #select
                    class="pf-input"
                    nzAllowClear
                    [nzServerSearch]="!!searchFacade"
                    [(nzOpen)]="pfOpen"
                    [nzMode]="multiple ? 'multiple' : 'default'"
                    [nzMaxTagCount]="tagAmount"
                    [nzMaxTagPlaceholder]="tagPlaceHolder"
                    [nzShowSearch]="searchable"
                    [nzLoading]="loading"
                    [nzDisabled]="pfDisabled"
                    [nzPlaceHolder]="placeholder"
                    [nzOptionHeightPx]="pfOptionHeightPx"
                    [formControl]="formControl"
                    [nzShowArrow]="!pfDisabled"
                    [nzDropdownMatchSelectWidth]="false"
                    [nzNotFoundContent]="notFoundContent"
                    (nzOpenChange)="onOpenChange($event)"
                    (nzOnSearch)="onSearchHandler($event)"
                    [nzDropdownRender]="actionRenderTemplate"
                    [nzPlacement]="placement"
                    (ngModelChange)="onChange($event)">
                    @if (loading) {
                        <nz-option nzDisabled nzCustomContent>
                            <span
                                nz-icon
                                nzType="loading"
                                class="loading-icon"></span>
                            Loading Data...
                        </nz-option>
                    }
                    @if (!noDefaultOption && !pfRequired && !multiple) {
                        <nz-option [nzValue]="" nzLabel=""></nz-option>
                    }
                    @if (grouped) {
                        @for (group of groupedData$ | async; track group.name) {
                            <ng-template #groupLabelTemplate>
                                <span (click)="onGroupClick(group)">{{
                                    group.name
                                }}</span>
                            </ng-template>
                            @if (group.name) {
                                <nz-option-group [nzLabel]="groupLabelTemplate">
                                    @for (
                                        option of group.options;
                                        track option.value
                                    ) {
                                        <nz-option
                                            [nzValue]="option.value"
                                            [nzLabel]="
                                                option.alias ||
                                                option.label ||
                                                ''
                                            "
                                            [nzDisabled]="
                                                option.disabled
                                            "></nz-option>
                                    }
                                </nz-option-group>
                            } @else {
                                @for (
                                    option of group.options;
                                    track option.value
                                ) {
                                    <nz-option
                                        [nzValue]="option.value"
                                        [nzLabel]="
                                            option.alias || option.label || ''
                                        "
                                        [nzDisabled]="
                                            option.disabled
                                        "></nz-option>
                                }
                            }
                        }
                    }
                    @if (!grouped) {
                        @for (
                            option of flatData$ | async | safeArray;
                            track option.value
                        ) {
                            <nz-option
                                [nzValue]="option.value"
                                [nzLabel]="option.alias || option.label || ''"
                                [nzDisabled]="option.disabled"></nz-option>
                        }
                    }
                </nz-select>
                <ng-template #actionRenderTemplate>
                    @if (dropdownAction) {
                        <nz-divider></nz-divider>
                        <div class="action-container">
                            <input
                                type="text"
                                nz-input
                                #inputElement
                                [attr.hidden]="
                                    !dropdownAction.input ? true : null
                                " />
                            <pf-button
                                [buttonType]="dropdownAction.buttonType"
                                class="action-btn"
                                (click)="actionHandler(inputElement.value)">
                                {{ dropdownAction.label }}
                            </pf-button>
                        </div>
                    }
                </ng-template>
            }
            @if (tree) {
                <nz-tree-select
                    #treeSelect
                    class="pf-input"
                    nzAllowClear
                    [nzMultiple]="multiple"
                    [nzMaxTagCount]="tagAmount"
                    [nzMaxTagPlaceholder]="tagPlaceHolder"
                    [nzShowSearch]="searchable"
                    [nzDisabled]="pfDisabled"
                    [nzPlaceHolder]="placeholder"
                    [formControl]="formControl"
                    [nzDropdownMatchSelectWidth]="false"
                    [nzAsyncData]="!!treeSearchFacade"
                    [nzExpandedKeys]="expandedKeys"
                    [nzNodes]="treeData"
                    [nzShowLine]="true"
                    [nzExpandedIcon]="expandIconTemplate"
                    [nzNotFoundContent]="notFoundContent"
                    nzVirtualHeight="300px"
                    nzHideUnMatched="true"
                    (nzExpandChange)="onTreeExpandChange($event)"
                    (nzOpenChange)="onOpenChange($event)"
                    (ngModelChange)="onTreeChange($event)"></nz-tree-select>
                <ng-template #expandIconTemplate let-node let-origin="origin">
                    @if (origin.isLeaf && node.icon) {
                        <pf-icon [iconType]="node.icon"></pf-icon>
                    }
                    @if (!origin.isLeaf) {
                        <pf-icon
                            [iconType]="
                                node.isExpanded ? 'collapseTree' : 'expandTree'
                            "></pf-icon>
                    }
                </ng-template>
            }
            <ng-content select="[input-suffix]"></ng-content>
        </div>
    </nz-form-control>
</nz-form-item>
